import toString from './to-string';
var lowerFirst = function (value) {
  var str = toString(value);
  return str.charAt(0).toLowerCase() + str.substring(1);
};
export default lowerFirst;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_util@2.0.17@@antv/util/esm/lower-first.js
// module id = 81
// module chunks = 0